casewidth-checkboxes
  .checkboxes(class="{ props.type } { props.mobile ? 'sp' : 'pc' }")
    .labels
      template(each="{(caseWidthMaster, index) in state.caseWidthMasters}")
        label
          template(if="{ props.type === 'in_modal' }")
            img(src="{checkboxOnIcon}" class="checkbox-icon { state.caseWidthes.includes(caseWidthMaster.caseWidth) ? '' : 'hidden' }")
            img(src="{checkboxOffIcon}" class="checkbox-icon { state.caseWidthes.includes(caseWidthMaster.caseWidth) ? 'hidden' : '' }")
          input(type="checkbox" onchange="{didChangeCaseWidth}" name="cw[{index}]" value="{ caseWidthMaster.caseWidth }"
                checked="{ state.existCaseWidth.includes(caseWidthMaster.caseWidth) }")
          | { caseWidthMaster.text }
    .selects
      .select-wrap
        select(name="case_width_bottom" id="case_width_bottom" onchange="{ didSelectCaseWidthRange }")
          option
          option(value="0" selected="{ '0' === state.initialBottom }") 下限なし
          option(each="{caseWidthRangeMaster in state.caseWidthRangeMasters}" value="{ caseWidthRangeMaster.caseWidth }"
                selected="{ caseWidthRangeMaster.caseWidth === state.initialBottom }") { caseWidthRangeMaster.text }
      | &nbsp;〜&nbsp;
      .select-wrap
        select(name="case_width_top" id="case_width_top" onchange="{didSelectCaseWidthRange}")
          option
          option(value="1000" selected="{ '1000' === state.initialTop }") 上限なし
          option(each="{caseWidthRangeMaster in state.caseWidthRangeMasters}" value="{ caseWidthRangeMaster.caseWidth }"
                selected="{ caseWidthRangeMaster.caseWidth === state.initialTop }") { caseWidthRangeMaster.text }
  style(type="scss").
    .checkboxes {
      .labels {
        display: flex;
        flex-wrap: wrap;
        label {
          display: flex;
          align-items: center;
          width: calc(100% / 3);
          input {
            margin-right: 4px;
          }
        }
      }
      .selects {
        select {
          color: #015205;
          font-weight: bold;
          border-color: #c8c8c8;
        }
      }
      &.in_sidebar {
        margin-top: 10px;
        border-top: 2px solid #e8e8e8;
        border-bottom: 1px solid #e8e8e8;
        .labels {
          label {
            border-top: 1px solid #e8e8e8;
            border-bottom: 2px solid #e8e8e8;
            border-left: 1px solid #e8e8e8;
            padding: 12px 3px;
            &:nth-child(3n+1) {
              border-left: 0;
            }
          }
        }
        .selects {
          width: 100%;
          border-top: 1px solid #e8e8e8;
          border-bottom: 2px solid #e8e8e8;
          padding: 13px 0;
          text-align: center;
          font-size: 12px;
          select {
            font-size: 12px;
          }
        }
        &.pc {
          .selects {
            display: flex;
            justify-content: center;
            align-items: baseline;
          }
          label {
            a {
              font-size: 12px;
              &:hover {
                text-decoration: underline;
              }
            }
          }
        }
        &.sp {
          margin-top: 16px;
          border-bottom: 0;
          .labels {
            label {
              border-top: 0;
              border-left-width: 2px;
              font-size: 15px;
            }
          }
          .selects {
            border-top: none;
            font-size: 16px;
            text-align: left;
            padding: 13px;
            select {
              width: 30%;
              height: 20px;
              border: none;
              margin-right: 4px;
            }
          }
        }
      }
      &.in_modal {
        margin-right: -5.625vw;
        width: calc(100% + 5.625vw);
        .labels {
          width: 100%;
          row-gap: 11.25vw;
        }
        label {
          width: calc(100% / 3);
          color: #6c6c6c;
          font-size: 4.6875vw;
          font-weight: 700;
          display: flex;
          align-items: center;
          input {
            display: none;
          }
          .checkbox-icon {
            height: 6.40625vw;
            width: 6.40625vw;
            margin-right: 1.25vw;
            &.hidden {
              display: none;
            }
          }
        }
        .selects {
          margin-top: 11.25vw;
          color: #a1a1a1;
          padding: 0;
          display: flex;
          align-items: center;
          font-size: 5vw;
          .select-wrap {
            width: 40.625vw;
            display: flex;
            align-items: center;
            position: relative;
            &::after {
              content: "▼";
              color: #a1a1a1;
              font-size: 5vw;
              line-height: 1;
              position: absolute;
              top: calc(50% - 2.5vw);
              right: 2.1875vw;
            }
          }
          select {
            border: 0.46875vw solid #e8e8e8;
            color: #5b5b5b;
            font-size: 4.6875vw;
            font-weight: 700;
            height: 15.625vw;
            width: 40.625vw;
            appearance: none;
            background: #ffffff;
            margin: 0;
            padding-left: 3.28125vw;
          }
        }
      }
    }
  script.
    import checkboxOnIcon from 'tags/smartsearch/checkbox_t.png'
    import checkboxOffIcon from 'tags/smartsearch/checkbox_f.png'
    import SmartsearchMaster from 'models/smartsearch-master.js'

    const getExistQuery = (key) => {
      const result = (new RegExp('[?&]'+encodeURIComponent(key)+'=([^&]*)')).exec(location.search)
      if(result) return result[1]
    }

    export default {
      checkboxOnIcon,
      checkboxOffIcon,
      onBeforeMount(props, state) {
        const masterData = new SmartsearchMaster()
        state.caseWidthMasters = props.casewidthes ? JSON.parse(props.casewidthes).map(current => ({ caseWidth: current.size, text: `${current.size}mm` })) : masterData.caseWidthMasters
        state.caseWidthRangeMasters = masterData.caseWidthRangeMasters
        state.caseWidthValues = state.caseWidthMasters.map(current => current.caseWidth)
        state.initialBottom = '0'
        state.initialTop = '1000'

        state.existCaseWidth = []
        state.caseWidthes = []
      },
      didSelectCaseWidthRange() {
        const bottom = this.root.querySelector('#case_width_bottom').value
        const top = this.root.querySelector('#case_width_top').value
        const caseWidthQuery = this.state.caseWidthQuery
        if (!bottom && !top || Number(top) < Number(bottom)) {
          const caseWidthRangeQuery = undefined
          this.update({ caseWidthRangeQuery })
          this.props.onUpdate(caseWidthQuery, caseWidthRangeQuery)
          return
        }
        if (!bottom || !top) return

        const caseWidthRangeQuery = bottom + '-' + top
        this.update({ caseWidthRangeQuery })
        this.props.onUpdate(caseWidthQuery, caseWidthRangeQuery)
      },
      didChangeCaseWidth() {
        const caseWidthElements = this.root.querySelectorAll('.checkboxes input')
        const caseWidthes = Array.prototype.map.call(caseWidthElements, (c) => {
          return c.checked || c.type == 'hidden' ? c.value : ''
        }).filter(range => range.length > 0)
        const caseWidthQuery = caseWidthes.join(',')
        this.update({
          caseWidthQuery,
          caseWidthes
        })
        this.props.onUpdate(caseWidthQuery, this.state.caseWidthRangeQuery)
      },
      initializeByExistQuery() {
        const existCaseWidth = getExistQuery('cw')
        if(existCaseWidth) {
          this.state.existCaseWidth = decodeURIComponent(existCaseWidth).split(',')
          this.state.caseWidthes = this.state.existCaseWidth
        }
        const existCaseWidthRange = getExistQuery('cwr')
        if(existCaseWidthRange) {
          const selectedCaseWidths = decodeURIComponent(existCaseWidthRange).split('-')
          if(selectedCaseWidths.length < 2) return

          this.state.initialBottom = selectedCaseWidths[0]
          this.state.initialTop = selectedCaseWidths[1]
        }
        this.update()
      },
      urlFromValueWithFormData(value) {
        const queryKey = 'cw'
        if (!this.props.formdata) return

        const formDataObj = Object.fromEntries(Array.from(this.props.formdata.entries()))

        const currentValues = (this.state.caseWidthQuery || '').split(',')
        if (!currentValues.includes(value)) {
          const values = Array.from(this.state.caseWidthValues).filter( v => (currentValues.includes(v) || value == v) )
          formDataObj[queryKey] = values.join(',')
        }
        const formDataArray = Array.from(Object.entries(formDataObj)).sort((kv1, kv2) => {
          if (kv1 < kv2) { return -1 }
          else if (kv1 > kv2) { return 1 }
          else return 0
        })
        const url = '/watches/?' + formDataArray.filter( kv => !!kv[1] ).map( kv => kv[0] + '=' + kv[1] ).join('&')
        return url
      },
      onMounted(props, state) {
        this.initializeByExistQuery()
        this.update()
      },
    }
